/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * What a workflow step does to the outside world. Derived from the action kind and tool name, never
 * from anything a generated workflow asserts about itself.
 */
export enum EnumWorkflowStepEffect {
    /**
     * Touches nothing outside the workflow.
     */
    None = 0,
    /**
     * Reads external data.
     */
    Read = 1,
    /**
     * Changes external data; drives the "diese Schritte ändern Daten" warning.
     */
    Write = 2,
    /**
     * Asks the user something and blocks until they answer.
     */
    Ask = 3,
}
